export default __webpack_public_path__ + "static/media/industrial-architecture-buildings.e24d7a71.svg";